import form from './form';
import shared from './shared';
// @generator sagas:import
export const allSagas = [
	// @generator sagas:export
	{ key: 'shared', value: shared },
	{ key: 'form', value: form },
];

export function injectSaga(store, { key, asyncSaga }, history) {
	const isInjected = (k) => store.injectedSagas.has(k);
	if (isInjected(key)) return;
	// Reset injected Sagas
	// store.injectedSagas = new Map();

	const task = store.runSaga(asyncSaga, history);
	store.injectedSagas.set(key, task);
}
